import React from 'react';

function BettingLines({ label, line, hasOutline = true }) {
  const hasOutlineClass = hasOutline ? "mls-o-odds__line--outline" : "mls-o-odds__line--no-outline";

  return (
    <div className={`mls-o-odds__line ${hasOutlineClass}`}>
      <div className="mls-o-odds__label">
        {label}
      </div>
      <div className={`mls-o-odds__line-container`}>
        <div className="mls-o-odds__line-value">
          {line}
        </div>
      </div>
    </div>
  );
}

// eslint-disable-next-line no-func-assign
BettingLines = React.memo(BettingLines);

export default BettingLines;
